import React, { Component } from 'react'
import {Button, Modal} from 'semantic-ui-react'

class CancelConfirmModal extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    let {cancelVpo, onClose, open} = this.props
    return (
      <Modal size='small' open={open} onClose={onClose} closeIcon>
        <Modal.Header>
          Confirm Cancel
        </Modal.Header>
        <Modal.Content>
          Are you sure you want to <b style={{color: 'red'}}>CANCEL</b> vpos?
        </Modal.Content>
        <Modal.Actions>

          <Button
            content="YES, CONFIRM CANCEL"
            labelPosition='right'
            icon='trash'
            onClick={cancelVpo}
            negative
          />

          <Button onClick={onClose}>
            NO, DO NOT CANCEL VPOS
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default CancelConfirmModal
